import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import Layout from "../../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { hidetoast, useDecodeToken } from "../../../Utils/function";
import { useAddCenMutation, useEditCenMutation } from "../../../store/Api/cen";
import AUditFormUi from "./AUditFormUi";
import {
  useAddAuditQuestionMutation,
  useEditAuditQuestionMutation,
} from "../../../store/Api/auditsQuestions";

// Define validation schema using Yup
const validationSchema = Yup.object().shape({
  question: Yup.string()
    .required("Question is required"),
  input_type: Yup.string().required("Input Type is required"),
  dropdown_type: Yup.string().when("input_type", {
    is: "dropdown",
    then: (schema) => schema.required("Dropdown Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  checkbox_type: Yup.string().when("input_type", {
    is: "checkbox",
    then: (schema) => schema.required("Checkbox Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  min: Yup.string().when("dropdown_type", {
    is: (value) => value === "numeric" || value === "autogenerate",
    then: (schema) =>
      schema
        .required("Min is required")
        .test(
          "is-valid-number",
          "Min must be a number",
          (value) => !isNaN(value)
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  max: Yup.string().when("dropdown_type", {
    is: (value) => value === "numeric" || value === "autogenerate",
    then: (schema) =>
      schema
        .required("Max is required")
        .test(
          "is-valid-number",
          "Max must be a number",
          (value) => !isNaN(value)
        )
        .test("is-greater", "Max must be greater than Min", function (value) {
          const { min } = this.parent; // Access the sibling field value
          return !min || !value || parseFloat(value) > parseFloat(min);
        }),
    otherwise: (schema) => schema.notRequired(),
  }),
  title: Yup.string().when("dropdown_type", {
    is: "autogenerate",
    then: (schema) => schema.required("Title is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // answer: Yup.string().when("input_type", {
  //   is: (value) => value !== "checkbox",
  //   then: (schema) => schema.required("Answer is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});
function AuditForm() {
  const dispatch = useDispatch();
  const location = useLocation(); // Access state
  const { state } = location;
  const id = state?.id;
  
  const url = window.location.pathname;
  // const { id } = useParams();
  let disabled =
    url === `${process.env.REACT_APP_BASE_NAME}/view-audit-question/${id}`
      ? true
      : false;
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  
  const [addAuditQuestion] = useAddAuditQuestionMutation();
  const [updateAuditQuestion] = useEditAuditQuestionMutation();
  const [isOpetionError, setIsOpetionError] = useState("");
  const [subQuestionErrors, setSubQuestionsErrors] = useState([]);
  const [callvalidation,setCallValidation] = useState("");
  const [subQuestionDeletedId,setSubQuestionDeletedId] = useState([])
  let updateData = state;
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  const validateSubQuestions = (values) => {
    const errors = {};
    const subQuestionErrors = [];
    
    values.sub_question?.forEach((sub, index) => {
      const subErrors = {};

      // Validate Question
      if (!sub?.question || sub?.question.trim() === "") {
        subErrors.question = "Question is required";
      }

      // Validate Input Type
      if (!sub?.input_type || sub?.input_type.trim() === "") {
        subErrors.input_type = "Input type is required";
      }

      // Validate Dropdown Type
      if (
        sub?.input_type === "dropdown" &&
        (!sub?.dropdown_type || sub?.dropdown_type.trim() === "")
      ) {
        subErrors.dropdown_type = "Dropdown type is required";
      }

      // Validate Checkbox Type
      if (
        sub?.input_type === "checkbox" &&
        (!sub?.checkbox_type || sub?.checkbox_type.trim() === "")
      ) {
        subErrors.checkbox_type = "Checkbox type is required";
      }

      // Validate Min and Max for Numeric/Autogenerate Dropdown
      if (
        sub?.dropdown_type &&
        (sub?.dropdown_type === "numeric" ||
          sub?.dropdown_type === "autogenerate")
      ) {
        if (!sub?.min && sub?.min !== 0) {
          subErrors.min = "Min is required";
        } else if (isNaN(sub?.min)) {
          subErrors.min = "Min must be a number";
        }

        if (!sub?.max) {
          subErrors.max = "Max is required";
        } else if (isNaN(sub?.max)) {
          subErrors.max = "Max must be a number";
        } else if (sub?.min && parseFloat(sub?.max) <= parseFloat(sub?.min)) {
          subErrors.max = "Max must be greater than Min";
        }
      }

      // Validate Title for Autogenerate Dropdown
      if (
        sub?.dropdown_type === "autogenerate" &&
        (!sub?.title || sub?.title.trim() === "")
      ) {
        subErrors.title = "Title is required";
      }

      // Validate Answer
      // if (
      //   sub?.input_type !== "checkbox" &&
      //   (!sub?.answer || sub?.answer.trim() === "")
      // ) {
      //   subErrors.answer = "Answer is required";
      // }

      // Validate Options
      if (  (sub?.checkbox_type == "single" ||
        sub?.input_type == "radio" ||
        sub?.dropdown_type == "custom") && !sub?.options || sub?.options?.length === 0) {
        subErrors.options = "At least one option is required";
      } else {
        let isError = false;
        sub?.options?.forEach((option) => {
          if (!option.trim()) {
            isError = true;
          }
        });
        if (
          isError &&
          (sub?.checkbox_type === "single" ||
            sub?.input_type === "radio" ||
            sub?.dropdown_type === "custom")
        ) {
          subErrors.options = "Option cannot be empty";
        }
      }

      // Add sub-errors to subQuestionErrors
      if (Object.keys(subErrors)?.length > 0) {
        subQuestionErrors[index] = subErrors;
      }
    });

    // Add subQuestionErrors to main errors object
    if (subQuestionErrors?.length > 0) {
      errors.sub_question = subQuestionErrors;
    }

    return errors;
  };
  const handleEmptyOrStringify = (field) => {
    if ((field?.length === 1 && field[0] === "") || !field || field == "null" || (Array.isArray(field) && field.length === 0) ) {
      return null;
    }
    return JSON.stringify(field);
  };
  
  const dataNull = (values) => {
      const data = values.map((obj,index) => {        
      const filteredAnswer = obj?.answer !== null ? obj?.answer?.filter((item) => item !== "") : null;
      obj = {
        ...obj,
        mandatory: (obj?.mandatory == "" || !obj?.mandatory)? false : true,
        multiline: (obj?.multiline == "" || !obj?.multiline)? false : true,
        options: handleEmptyOrStringify(obj?.options),
        answer: handleEmptyOrStringify(filteredAnswer),
        sequence:index + 1,
      }
      const processedObj = {};
      for (const [key, value] of Object.entries(obj)) {
        processedObj[key] =
          typeof value === "string"
            ? value.trim() === ""
              ? null
              : value.trim()
            : value;
      }
      return processedObj;
    });
    return data;
  };
  const handleSubmit = async (values) => {
    let isError = false;
    let error = [];
    if (values.input_type == "checkbox" && values.checkbox_type == "multiple") {
      error = validateSubQuestions(values);
      if(Object.keys(error).length === 0){
        const dataSub = dataNull(values?.sub_question);
        values = {
          ...values,
          sub_question: dataSub,
        };
      }
    } else {
      values = {
        ...values,
        sub_question: null,
      };
    }

    if (values.options) {
      values.options.forEach((name) => {
        if (!name.trim()) {
          isError = true;
        }
      });
    } else {
      isError = true;
    }
    if (
      isError &&
      (values.checkbox_type == "single" ||
        values.input_type == "radio" ||
        values.dropdown_type == "custom")
    ) {
      setIsOpetionError("Opetions is required");
    } else if (
      values.input_type === "checkbox" &&
      values.checkbox_type === "multiple" &&
      error?.sub_question?.length > 0
    ) {
      setSubQuestionsErrors(error?.sub_question);
    } else {
      const filteredAnswer =values?.answer !== null ? values?.answer?.filter((item) => item !== "") : null;
      values = {
        ...values,
        options: handleEmptyOrStringify(values?.options),
        answer: handleEmptyOrStringify(filteredAnswer),
        subQuestionDeletedId:subQuestionDeletedId.length > 0 ? subQuestionDeletedId : null
      };

      const data = Object.fromEntries(
        Object.entries(values).map(([key, value]) => [
          key,
          typeof value === "string"
          ? value.trim() === ""
            ? null
            : value.trim()
          : value
        ])
      );

      // const data = Object.fromEntries(
      //   Object.entries(values).map(([key, value]) => [
      //     key,
      //     typeof value === "string" ? value.trim() : value,
      //   ])
      // );
      try {
        const response = id
          ? await updateAuditQuestion({ id, data })
          : await addAuditQuestion(data);
        if (response?.data?.success) {
          navigate("/audits-questions");
        }
      } catch (error) {
        console.log(error, "Audit Form error");
      }
    }
  };
  const addNewOptionsField = (formik) => {
    const currentoptions = formik.values.options || [];
    formik.setFieldValue("options", [...currentoptions, ""]);
  };

  const handleCenChange = (formik, index, value) => {
    const currentoptions = [...formik.values.options];
    currentoptions[index] = value;
    formik.setFieldValue("options", currentoptions);
    setIsOpetionError("");
  };

  const removeOptionsField = (formik, index) => {
    const currentoptions = [...formik.values.options];
    currentoptions.splice(index, 1);
    formik.setFieldValue("options", currentoptions);
  };
  const addNewSubQuetionField = (formik) => {
    const current = formik.values?.sub_question || [];
    formik.setFieldValue("sub_question", [
      ...current,
      {
        question: "",
        input_type: "",
        dropdown_type: "",
        manatory: false,
        checkbox_type: "",
        multiline: false,
        answer: [""],
        options: [""],
        min: "",
        max: "",
        title: "",
        
      },
    ]);
  };
  const removeSubQuetionField = (formik, index) => {
    const current = [...formik.values.sub_question];
    let arr = subQuestionDeletedId
    const id = current[index]?.id
    arr.push(id)
    setSubQuestionDeletedId(arr)
    current.splice(index, 1);
    formik.setFieldValue("sub_question", current);
  };
  const handleSubQuestionChange = (formik, index, value, fieldName) => {

    const current = [...formik.values.sub_question];
    // Update only the specific field using fieldName
    current[index] = {
      ...current[index], // Preserve other fields
      [fieldName]: value, // Update the field specified by fieldName
    };
    if(fieldName == "input_type"){
      current[index] = {
        ...current[index], 
        ["dropdown_type"]: "", 
        ["multiline"]:false,
        ["answer"]:[""],
        ["checkbox_type"]:"",
        ["options"]:[""],
        ["min"]: "",
        ["max"]: "",
        ["title"]: "",
      };
    }
    formik.setFieldValue("sub_question", current);
    const temVal = callvalidation  ? !callvalidation : true
    
    setCallValidation(temVal)
    // const error = validateSubQuestions(formik?.values);
    //   if( error?.sub_question?.length > 0){
    //     setSubQuestionsErrors(error?.sub_question);
    //   }
  };
  const addSubQuestonOptionField = (formik, index) => {
    const currentopstin = formik.values.sub_question[index].options || [];
    const current = [...formik.values.sub_question];
    // Update only the specific field using fieldName
    current[index] = {
      ...current[index], // Preserve other fields
      ["options"]: [...currentopstin, ""], // Update the field specified by fieldName
    };
    formik.setFieldValue("sub_question", current);
  };
  const removeSubQuestionOptionsField = (formik, index, ind) => {
    const currentopstin = formik.values.sub_question[index].options || [];
    const current = [...formik.values.sub_question];
    currentopstin.splice(index, 1);
    // Update only the specific field using fieldName
    current[index] = {
      ...current[index], // Preserve other fields
      ["options"]: currentopstin, // Update the field specified by fieldName
    };
    formik.setFieldValue("sub_question", current);
  };
  const handleSubQuetionsOptionsChange = (formik, index, ind, value) => {
    const currentopstin = formik.values.sub_question[index].options || [];
    const current = [...formik.values.sub_question];
    currentopstin[ind] = value;
    // Update only the specific field using fieldName
    current[index] = {
      ...current[index], // Preserve other fields
      ["options"]: currentopstin, // Update the field specified by fieldName
    };
   
    formik.setFieldValue("sub_question", current);
  };
 

  return (
    <Layout>
      <Formik
        initialValues={{
          question: id ? updateData.question : null,
          input_type: id ? updateData.input_type : null,
          dropdown_type: id ? updateData.dropdown_type : null,
          mandatory: id ? updateData.mandatory : false,
          checkbox_type: id ? updateData.checkbox_type : null,
          options: id ? (updateData.options == null ? [""] : updateData?.options) : [""],
          multiline: id ? updateData.multiline : false,
          answer: id ? updateData.answer : [""],
          min: id ? updateData.min : null,
          max: id ? updateData.max : null,
          title: id ? updateData.title : null,
          reference_para: id ? updateData?.reference_para : null,
          sub_question: id
            ? updateData.sub_question
            : [
                {
                  question: null,
                  input_type: null,
                  dropdown_type: null,
                  mandatory: false,
                  multiline: false,
                  checkbox_type: null,
                  min: null,
                  max: null,
                  title: null,
                  options: [""],
                  answer: null,
               
                },
              ],
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <AUditFormUi
            formik={formik}
            id={id}
            addNewOptionsField={() => addNewOptionsField(formik)}
            handleCenChange={(index, value) =>
              handleCenChange(formik, index, value)
            }
            removeOptionsField={(index) => removeOptionsField(formik, index)}
            decodedToken={decodedToken}
            isOpetionError={isOpetionError}
            disabled={disabled}
            handleSubQuestionChange={(index, value, fieldName) =>
              handleSubQuestionChange(formik, index, value, fieldName)
            }
            removeSubQuetionField={(index) =>
              removeSubQuetionField(formik, index)
            }
            addNewSubQuetionField={() => addNewSubQuetionField(formik)}
            addSubQuestonOptionField={(index) =>
              addSubQuestonOptionField(formik, index)
            }
            removeSubQuestionOptionsField={(index, ind) =>
              removeSubQuestionOptionsField(formik, index, ind)
            }
            handleSubQuetionsOptionsChange={(index, ind, value) => {
              handleSubQuetionsOptionsChange(formik, index, ind, value);
            }}
            subQuestionErrors={subQuestionErrors}
            validateSubQuestions={validateSubQuestions}
            setSubQuestionsErrors={setSubQuestionsErrors}
            callvalidation={callvalidation}
            toast={toast}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default AuditForm;
